export enum Slugs {
  Employees = 'employees',
  Platforms = 'new-folder-games-platforms',
  Downloads = 'downloads',
  Stores = 'stores',
  Subtitle = 'subtitle',
  Description = 'description',
  Background = 'background',
  MediaEmail = 'media_email',
  CareerEmail = 'career_email',
  ContactsBackground = 'contacts-background',
  Picture1 = 'picture-1',
  Picture2 = 'picture-2',
  Picture3 = 'picture-3',
}

export enum SettingGroups {
  AboutUs = 'new-folder-games',
  Employees = 'employees',
  Contacts = 'contacts',
}
